/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'accordion-content.scss' instead.
import { css } from 'lit';
export default css `:host([slot=content]){margin-top:0!important}:host([slot=content]) ::slotted(:first-child){margin-top:0!important}`;
//# sourceMappingURL=accordion-content.scss.js.map